import { createContext, useCallback, useContext, useMemo, useState } from "react";
import MatchCelebrationModal from "../components/MatchCelebrationModal";
import { resolveMatchCelebration } from "../util/match";

const MatchCelebrationContext = createContext(null);

function getCurrentUserId() {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.id ?? null;
  } catch {
    return null;
  }
}

export function MatchCelebrationProvider({ children }) {
  const [celebration, setCelebration] = useState(null);

  const showMatchCelebration = useCallback((payload) => {
    if (payload?.matchedUser) {
      setCelebration(payload);
    }
  }, []);

  const clearMatchCelebration = useCallback(() => {
    setCelebration(null);
  }, []);

  const celebrateFromLikeResponse = useCallback(
    async (likeResponse, fallbackUser, options = {}) => {
      const currentUserId = options.currentUserId ?? getCurrentUserId();
      const payload = await resolveMatchCelebration(likeResponse, fallbackUser, {
        ...options,
        currentUserId,
      });
      if (payload) {
        setCelebration(payload);
      }
      return Boolean(payload);
    },
    []
  );

  const value = useMemo(
    () => ({
      showMatchCelebration,
      clearMatchCelebration,
      celebrateFromLikeResponse,
    }),
    [showMatchCelebration, clearMatchCelebration, celebrateFromLikeResponse]
  );

  return (
    <MatchCelebrationContext.Provider value={value}>
      {children}
      <MatchCelebrationModal
        isOpen={Boolean(celebration)}
        onClose={clearMatchCelebration}
        matchedUser={celebration?.matchedUser}
        conversationId={celebration?.conversationId}
      />
    </MatchCelebrationContext.Provider>
  );
}

export function useMatchCelebration() {
  const ctx = useContext(MatchCelebrationContext);
  if (!ctx) {
    throw new Error("useMatchCelebration must be used within MatchCelebrationProvider");
  }
  return ctx;
}
